<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="ch00_fm01_fflap"></a><a id="page_fp1"></a>“Baked Elements . . . <em>is arranged by our favorite ingredients, ten distinct flavor elements from which to build a range of recipes. These are the ingredients that we would take to a desert island or rescue from a burning house. They are the basis of our bakery, our books, and to some degree, our lives . . . While we can’t expect everyone’s top ten ingredients to match ours, we do hope the recipes turn into new favorites. Enjoy.</em>”—FROM THE INTRODUCTION</p>
<p class="noindent1">Matt Lewis and Renato Poliafito’s beloved bakery and sweets—sold in stores across the country—have garnered major critical acclaim. Their previous cookbooks have left fans clamoring for more. Here are the best of the best: seventy-five new recipes built around Lewis and Poliafito’s ten favorite ingredients.</p>
<p class="noindent1">PEANUT BUTTER: Crunchy Peanut Butter Banana Bread, Oopsy Daisy Cake, Peanut Butter Chocolate Whirligigs</p>
<p class="noindent1">LEMON AND LIME: Sunrise Key Lime Tarts, Lime Tarragon Cookies, Lemon Shaker Pie</p>
<p class="noindent1">CARAMEL: Caramel Coconut Cluster Bars, Alfajores, Turtle Thumbprint Cookies</p>
<p class="noindent1">BOOZE: Lacy Panty Cakes with Whiskey Sauce, Triple Rum Black Pepper Cake, Whiskey Peach Upside-Down Cake</p>
<p class="noindent1">PUMPKIN: Toasted Pumpkin Seed Brittle, Pumpkin Almond Cake with Almond Butter Frosting, Pumpkin Cinnamon Rolls</p>
<p class="noindent1">MALTED MILK POWDER: Devil Dogs with Malted Buttercream Frosting, Malted Madeleines, Vanilla Bean Malt Cake</p>
<p class="noindent1">CINNAMON: Spicy Brownies, Brown Butter Snickerdoodles, Cinnamon Chocolate Soufflés</p>
<p class="noindent1">CHEESE: Orange Almond Ricotta Cheesecake, Cheddar Corn Souffle, Poppy Seed Pound Cake with Brown Butter Glaze</p>
<p class="noindent1">CHOCOLATE: Chocolate Mayonnaise Cupcakes, Candy Bar Cookies, Tunnel of Hazelnut Fudge Cake</p>
<p class="noindent1">BANANA: Banana Whoopie Pies, Chocolate Banana Tart, Honey Banana Poppy Seed Bread</p>
<p class="noindent1">Cakes, cookies, bars, milkshakes, pies, brownies, tarts, and more—these sweets are perfect for everyday cravings, special occasions, late-night celebrations, and weekend get-togethers. Chapters also include infographics—quirky facts and charts on the featured ingredients—and helpful Baked notes that make creating these desserts as easy as pie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_fflap.vue?4cf8db4f